import { render, staticRenderFns } from "./ConfirmProfileUpdate.vue?vue&type=template&id=9b4ee8a0&scoped=true"
import script from "./ConfirmProfileUpdate.vue?vue&type=script&lang=ts"
export * from "./ConfirmProfileUpdate.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmProfileUpdate.vue?vue&type=style&index=0&id=9b4ee8a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4ee8a0",
  null
  
)

export default component.exports